import { render, staticRenderFns } from "./InputDigits.vue?vue&type=template&id=1c8058ae&"
import script from "./InputDigits.vue?vue&type=script&lang=js&"
export * from "./InputDigits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports